import type { APIPriorityTraversal } from '@ardoq/api-types';
import { fetchJson, Method, toRequestOptions } from './api';
import { ApiResponse } from './types';

const fetchPriorityTraversals = (): ApiResponse<APIPriorityTraversal[]> => {
  const request = new Request('/api/priority-traversal');
  return fetchJson<APIPriorityTraversal[]>(request);
};

// Replaces the list for priorityTraversal.componentTypeName only. Empty
// entries unpin everything for that component type.
const updatePriorityTraversal = (
  priorityTraversal: APIPriorityTraversal
): ApiResponse<APIPriorityTraversal> => {
  const request = new Request(
    '/api/priority-traversal',
    toRequestOptions(Method.PUT, priorityTraversal)
  );
  return fetchJson<APIPriorityTraversal>(request);
};

export const priorityTraversalApi = {
  fetchPriorityTraversals,
  updatePriorityTraversal,
};
